import { IApp } from "@/interfaces";
import { DigitalHumanSetting } from "@/store/modules/digital_human/interfaces";

const hygenCharacterName = String(
  process.env.VUE_APP_HYGEN_CHARACTER_NAME ||
    process.env.VUE_HYGEN_CHARACTER_NAME ||
    ""
).trim();

const digital_human_setting: Record<string, DigitalHumanSetting> = {
  [IApp.Portals.HCMS]: {
    bot_avatar: hygenCharacterName || "Katya_Chair_Sitting_public",
    bot_voice_id: "864a26b8-bfba-4435-9cc5-1dd593de5ca7"
  },
  [IApp.Portals.COREHCMS]: {
    bot_avatar: hygenCharacterName || "Kayla-incasualsuit-20220818",
    bot_voice_id: "864a26b8-bfba-4435-9cc5-1dd593de5ca7"
  },
  [IApp.Portals.COREHCS]: {
    bot_avatar: hygenCharacterName || "Kayla-incasualsuit-20220818",
    bot_voice_id: "864a26b8-bfba-4435-9cc5-1dd593de5ca7"
  },
  [IApp.Portals.INCEPTION]: {
    bot_avatar: hygenCharacterName || "Katya_Chair_Sitting_public",
    bot_voice_id: "864a26b8-bfba-4435-9cc5-1dd593de5ca7"
  }
};

export default digital_human_setting;
